export enum ECommerceProcessorEnum {
  PLEXO = 'PLEXO',
  BAMBOO = 'BAMBOO',
  OTRO = 'OTRO',
  PAYEXPRESS = 'PayExpress',
}
